import { render, staticRenderFns } from "./attrSpecManage.vue?vue&type=template&id=4559fd4a&scoped=true"
import script from "./attrSpecManage.vue?vue&type=script&lang=js"
export * from "./attrSpecManage.vue?vue&type=script&lang=js"
import style0 from "./attrSpecManage.vue?vue&type=style&index=0&id=4559fd4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4559fd4a",
  null
  
)

export default component.exports